import { Toaster } from 'sonner'

/**
 * Toast alerte-immo (direction « coche dessinée »).
 * Sonner en `unstyled` : tout le style vit dans index.css (.ai-toast).
 * L'icône est tracée une fois à l'apparition, jamais en boucle.
 */

function Mark({ paths }: { paths: string[] }) {
  return (
    <svg className="ait-mk" viewBox="0 0 24 24" aria-hidden="true">
      <circle className="ait-ring" cx="12" cy="12" r="10" />
      {paths.map((d) => (
        <path key={d} className="ait-draw" d={d} />
      ))}
    </svg>
  )
}

const icons = {
  success: <Mark paths={['M7 12.2l3.2 3.2L17 8']} />,
  error: <Mark paths={['M8.4 8.4l7.2 7.2', 'M15.6 8.4l-7.2 7.2']} />,
  warning: <Mark paths={['M12 7.2v5.4', 'M12 15.6v.01']} />,
  info: <Mark paths={['M12 8.2v.01', 'M12 11.4v4.8']} />,
  loading: (
    <svg className="ait-mk" viewBox="0 0 24 24" aria-hidden="true">
      <circle className="ait-ring" cx="12" cy="12" r="10" />
      <circle className="ait-spin" cx="12" cy="12" r="8" />
    </svg>
  ),
}

export function AppToaster() {
  return (
    <Toaster
      position="top-right"
      expand
      closeButton
      duration={4200}
      gap={10}
      icons={icons}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: 'ai-toast',
          title: 'ai-toast-title',
          description: 'ai-toast-desc',
          icon: 'ai-toast-icon',
          closeButton: 'ai-toast-close',
        },
      }}
    />
  )
}
